export default __webpack_public_path__ + "static/media/rgp_pvh_nca_mangistau_region_bw.4df47ba6.png";